import { useMemo } from 'react';
import { PictogramName } from '@cbhq/cds-common';
import { ContentCard, ContentCardBody, ContentCardHeader } from '@cbhq/cds-web/cards';
import { Pictogram } from '@cbhq/cds-web/illustrations';
import { Box } from '@cbhq/cds-web/layout';

import { useProfileMenuV2 } from '../ProfileMenu/providers/ProfileMenuV2Provider';

import { HelpMenuActions } from './HelpMenuActions';

export function HelpMenuDropdownContent() {
  const { helpMenu } = useProfileMenuV2();
  const { title, subtitle, pictogram } = helpMenu ?? {};

  const headerStyles = useMemo(() => ({ display: 'flex', justifyContent: 'center' }), []);

  return (
    <>
      {(title ?? subtitle ?? pictogram) && (
        <ContentCard gap={1}>
          {pictogram && (
            <Box width="100%" justifyContent="center">
              <Pictogram name={pictogram as PictogramName} dimension="64x64" />
            </Box>
          )}
          {title && <ContentCardHeader style={headerStyles} title={title} />}
          {subtitle && <ContentCardBody body={subtitle} />}
        </ContentCard>
      )}
      <HelpMenuActions />
    </>
  );
}
